
import { Markdown, TabBar, TabItem } from "@wot/components";
import { ILegal, ILegalType } from "@wot/typings";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import legalApi from "../../api/legal";
import { BACK_ARROW } from "../../assets/icons";
import { SEO } from "../../components/SEO";

export default function Legal() {
  const { type } = useParams();
  const [activeTab, setActiveTab] = useState<ILegalType>("terms-conditions");
  const navigate = useNavigate();
  const [document, setDocument] = useState<ILegal>();

  const onTabChange = (newValue: string) => {
    navigate(`/legal/${newValue}`)
  }


  useEffect(() => {
    if (type) {
      // @ts-ignore
      setActiveTab(type);
      if (type === "terms-conditions") {
        legalApi.getDocuments("terms-conditions")
          .then((data) => {
            setDocument(data[0])
          }).catch(err => console.log(err))
      } else {
        legalApi.getDocuments("privacy-policy")
          .then((data) => {
            setDocument(data[0])

          }).catch(err => console.log(err))
      }
    }
  }, [type]);

  return (
    <>
    <SEO 
      title={`${activeTab === 'terms-conditions' ? 'Terms of Service' : 'Privacy Policy'} - WorldoTutor`}
      description={activeTab === 'terms-conditions' ? 'Read the terms of service for using WorldoTutor platform.' : 'Read the privacy policy to understand how we collect, use, and protect your data.'}
      keywords="terms of service, privacy policy, legal, user agreement, data protection"
      url={`/legal/${activeTab}`}
      type="website"
      og={{
        type: 'website',
        siteName: 'WorldoTutor',
        locale: 'en_US',
        image: {
          url: '/imgi_1_favicon.png',
          alt: `${activeTab === 'terms-conditions' ? 'Terms of Service' : 'Privacy Policy'} - WorldoTutor`,
          width: 1200,
          height: 630
        }
      }}
      twitter={{
        card: 'summary_large_image',
        site: '@worldotutor',
        image: {
          url: '/imgi_1_favicon.png',
          alt: `${activeTab === 'terms-conditions' ? 'Terms of Service' : 'Privacy Policy'} - WorldoTutor`
        }
      }}
    />
    <div className="w-full flex flex-col">
      <div className="w-full md:w-[90%] mx-auto p-4 md:px-12 drop-shadow-md flex items-center">
        {/* <img src={NAV_LOGO} onClick={() => navigate("/")} className="h-10" /> */}
      </div>
      <div className="w-full md:w-[90%] h-full mx-auto px-4 md:px-12">
        <div className="flex items-center gap-2 cursor-pointer" onClick={() => navigate(-1)}>
          <img src={BACK_ARROW} className="w-3 h-3" />
          <p className="text-sm underline">Back</p>
        </div>
      </div>
      <div className="w-full md:w-[90%] h-full mx-auto mt-5 px-4 md:px-12">
        <div className="my-7 text-base overflow-x-scroll">
          <TabBar
            value={activeTab}
            indicatorColor="text-secondary"
            onChange={onTabChange}
            textColor="text-black"
          >
            <TabItem fontSize={22} label="Terms Of Service" value="terms-conditions" />
            <TabItem fontSize={22} label="Privacy Policy" value="privacy-policy" />
          </TabBar>
        </div>

        <div className="w-full">
          <Markdown markdown={document?.mdText || ''} />
        </div>
      </div>
    </div>
    </>

  )
}